import { useEffect, useRef, useState } from "react";
import { Zoom } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { commonErrorToastMessage } from "../toastify/AllToastifyErrors";

const TitleAndDomainInput = ({
  title,
  setTitle,
  titleInputRef,
  domain,
  handleDropdownChange,
  domainSelectRef,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [customValue, setCustomValue] = useState("");

  const otherButtonRef = useRef(null);

  const isYoutubeModalOpen = localStorage.getItem("isYoutubeModalOpen");

  // Title name change
  const handleTitleChange = (e) => {
    const { value } = e.target;

    // if (value.length > 50) {
    //   // Log error message to console when user enters more than 50 characters
    //   console.error("Title should be 50 chars.");
    //   commonErrorToastMessage("Title name must be under 50 characters");
    // }

    setTitle(value);
  };

  // "Other" menu visibility
  const handleSubMenuToggle = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
    setCustomValue(""); // Clear the custom value
    setInputError(false); // Also clear any input errors if present
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
    if (isSubMenuOpen) {
      // Close the submenu if the main dropdown is being toggled
      setIsSubMenuOpen(false);
      setCustomValue(""); // Clear the custom value
      setInputError(false); // Also clear any input errors if present
    }
  };

  const handleOptionSelect = (value, e) => {
    // e.stopPropagation(); // Prevent any parent handlers from being notified of the event
    const event = { target: { value } };
    handleDropdownChange(event);
    setIsDropdownOpen(false);
  };

  // Function to handle click outside of menu
  const handleClickOutside = (event) => {
    // Assuming the dropdown menu has a class "dropdown-menu", you can use a query selector to get it.
    const dropdownMenu = document.querySelector(".dropdown-menu");

    if (
      domainSelectRef.current &&
      !domainSelectRef.current.contains(event.target) &&
      otherButtonRef.current &&
      !otherButtonRef.current.contains(event.target) &&
      dropdownMenu &&
      !dropdownMenu.contains(event.target)
    ) {
      setIsDropdownOpen(false);
      setIsSubMenuOpen(false);
      setCustomValue(""); // Clear the custom value
      setInputError(false); // Also clear any input errors if present
    }
  };

  // Effect to add/remove event listener
  useEffect(() => {
    // If the dropdown is open, listen for clicks outside
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen, isSubMenuOpen]);

  const handleCustomValueChange = (e) => {
    const { value } = e.target;

    if (value.length > 20) {
      setInputError(true); // Show the error
      commonErrorToastMessage("Domain name must be under 20 characters");
      // Don't update the customValue state to prevent more characters
    } else {
      if (inputError) setInputError(false); // Hide the error message if previously shown
      setCustomValue(value);
    }
  };

  const handleCustomValueSubmit = (e) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      handleDropdownChange({ target: { value: customValue } });
      setIsDropdownOpen(false);

      // setSelectOpen(false); // Close the Select dropdown
      // handleSubMenuClose();
    }
  };

  return (
    <div className="flex place-content-between align-middle pl-[4.5rem]">
      {/* Title input */}
      <Tooltip
        title={title}
        arrow
        placement="bottom"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
      >
        <div className="flex border-b-2 border-[#ccbfff]">
          <span className="text-[#cc0000] text-3xl font-bold me-2">*</span>
          <input
            type="text"
            className="font-semibold outline-none title-input w-[24vw]"
            id="titleText"
            placeholder="Click to add a title"
            value={title}
            ref={titleInputRef}
            onChange={handleTitleChange} // Updated to use the new handler
            maxLength={50}
          />
        </div>
      </Tooltip>
    </div>
  );
};

export default TitleAndDomainInput;
